import { useCallback } from "react";
import { Row } from "react-native-col";

import { RadioItem } from "./radio-item";
import { createStyles, sizes } from "../theme";

type RadioOption<V extends string | number> = {
  label: string;
  value: V;
};

type Props<N extends string, V extends string | number> = {
  name: N;
  value: V | null;
  onChange: (name: N, value: V | null) => void;
  options: RadioOption<V>[];
};

export function RadioInput<N extends string, V extends string | number>({
  name,
  onChange,
  options,
  value,
}: Props<N, V>) {
  // Hooks
  const handleChange = useCallback(
    (newValue: string | number) => {
      onChange(name, newValue as V);
    },
    [name, onChange]
  );

  // Render
  return (
    <Row.L style={$.container}>
      {options.map((option) => (
        <RadioItem
          key={option.label}
          {...option}
          active={option.value === value}
          onPress={handleChange}
        />
      ))}
    </Row.L>
  );
}

const $ = createStyles({
  container: {
    gap: sizes["2"],
  },
});
